import React from 'react';
import { Marker } from 'react-leaflet';
import { Marker as MLMarker } from 'react-map-gl';
import {
  SERVICE_NEARBY_MARKER_TOOLTIP_OFFSET_X,
  SERVICE_NEARBY_MARKER_TOOLTIP_OFFSET_Y,
} from '#/shared/constants';
import featureFlags from '#/shared/feature-flags';
import useCenterOnMap from '#/map/hooks/useCenterOnMap';
import useComponentAsLeafletIcon from '#/map/hooks/useComponentAsLeafletIcon';
import MarkerTooltip from '#/map/components/MarkerTooltip';
import type { ServiceNearbyLocation } from './GeoLocation';
import * as Styled from './styled';

const { mapLibre } = featureFlags;

interface SelectedLocationMarkerProps {
  location: ServiceNearbyLocation;
}

function SelectedLocationMarker({
  location,
}: SelectedLocationMarkerProps): React.ReactElement {
  useCenterOnMap(location);

  const leafletIcon = useComponentAsLeafletIcon(
    <Styled.SelectedLocationIcon />
  );

  if (mapLibre) {
    return (
      <MLMarker longitude={location.lon} latitude={location.lat}>
        <Styled.SelectedLocationIcon />
      </MLMarker>
    );
  }
  return (
    <Marker icon={leafletIcon} position={[location.lat, location.lon]}>
      <MarkerTooltip
        offset={[
          SERVICE_NEARBY_MARKER_TOOLTIP_OFFSET_X,
          SERVICE_NEARBY_MARKER_TOOLTIP_OFFSET_Y,
        ]}
      >
        {location.address}
      </MarkerTooltip>
    </Marker>
  );
}

export default SelectedLocationMarker;
